import axios from '../../utils/axios';

export default function deleteLGCollectionTarget(adminId, targetId, data) {
    return (
        axios.post(`/admin/${adminId}/lGCollectionTarget/${targetId}/delete`,  data )
    )
}
